<template>
    <section class="small-left">
        <div class="spacing center gray">

            <lottie :name="'chapter-1/diagram-2-tas'" :width="500" :height="604" />

        </div>
        <div class="spacing space-between">

            <div>

                <h2>What is the Telephony Application Server (TAS)?</h2>
                <h3>With TAS you can offer exciting new services.</h3>

                <p>IMS supports multiple types of Application Server (AS), the key one being TAS, which enables new voice and video services via standard APIs in multi-access networks.</p>
                <p>Open APIs create fresh opportunities for CSPs by allowing them to customize call logic, extend functionality and create new services.</p>

            </div>

            <infobutton>
                A multitude of new services are possible in the areas of call direction, call control, call notification, user interaction, call history, terminal status and self-care. Create almost limitless business opportunities by combining these capabilities with various consumer and enterprise applications.
            </infobutton>

        </div>
    </section>
</template>

<script>

    import globalMixin from '@/mixins/globalMixin.js';

    export default {
        mixins: [globalMixin],
    }

</script>

<style lang="scss" scoped>

    // ...

</style>